import QuestionItem from "./QuestionItem";
import { Question } from "../../types/Question";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import React from "react";

interface QuestionsListProps {
    questions: Question[];
}

const QuestionsList: React.FC<QuestionsListProps> = ({ questions }) => {
    if (questions.length === 0) {
        return (
            <Typography variant="h5" display={"flex"} justifyContent={"center"} p={10}>
                No results found.
            </Typography>
        );
    }

    return (
        <Stack direction={"column"} spacing={3}>
            {questions.map((question) => (
                <QuestionItem question={question} key={question.id} />
            ))}
        </Stack>
    );
};

export default QuestionsList;
